import { createValidationErrors, ValidationLevel } from 'ui';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { SavedReportsValidation, SavedReportValidation } from 'app/area/shared/saved-reports/types-store';
import { CompanyReportAdminTranslation } from '../../constants';
import { SavedReportCompanyReport } from '../types-store';

export const validateSavedReport = (
  savedReport: SavedReportCompanyReport,
  currentSavedReportId: number,
  allSavedReportIs: number[],
  translation: CompanyReportAdminTranslation
): SavedReportValidation<SavedReportCompanyReport> => {

  const savedReportId = savedReport?.code?.value;

  return {
    ...(!isDefinedIncludingZero(savedReportId)
      ? {
        code: createValidationErrors([translation?.must_be_filled_out])
      }
      : (savedReportId !== currentSavedReportId && allSavedReportIs?.includes(savedReportId) && {
        code: createValidationErrors([translation?.saved_id_validation])
      })),
    ...((savedReport?.reportResultCell?.trim() ?? '').length === 0 && {
      reportResultCell: {
        level: ValidationLevel.error,
        messages: [{
          level: ValidationLevel.error,
          message: translation?.must_be_filled_out
        }]
      }
    })
  };
};

export const validateSavedReports = (
  savedReports: SavedReportCompanyReport[],
  translation: CompanyReportAdminTranslation
): SavedReportsValidation<SavedReportCompanyReport> => {

  return savedReports
    ?.reduce((result, savedReport) => {

      const validation = validateSavedReport(savedReport, savedReport.code.value, [], translation);

      if (Object.keys(validation).length === 0) {
        return result;
      }

      return {
        ...result,
        [savedReport.code.value]: validation
      };
    },
      {} as SavedReportsValidation<SavedReportCompanyReport>
    ) ?? {};
};
